import * as themeCart from '@shopify/theme-cart';
// import * as themeCart from '../../vendor/theme-cart';

// ----------------------------------
// State
// ----------------------------------
const state = {
  domestic: true,
  // eslint-disable-next-line no-template-curly-in-string
  currency: window.Shop._MONEY_FORMAT_,
  cart: {
    attributes: {
      pricing_key: '{}',
    },
    item_count: '',
    items: [],
    total_weight: 0,
  },
  loading: 0,
};

// ----------------------------------
// Getters
// ----------------------------------
const getters = {
  cart: state => {
    return state.cart;
  },
  cartCount: state => {
    return state.cart.item_count;
  },
  totalPrice: state => {
    return state.cart.total_price;
  },
  loading: state => {
    return state.loading;
  },
  currency: state => {
    return state.currency;
  },
};

// ----------------------------------
// Actions
// ----------------------------------
const actions = {
  updateCart: ({ commit, dispatch }) => {
    themeCart
      .getState()
      .then(cart => {
        return commit('UPDATE_CART', cart);

      })
      .catch(error => console.log(`updateCart Error: ${error}`));
  },
  addItem: ({ commit, dispatch }, payload) => {
    const id = payload.id;
    const props = payload.props;
    commit('LOADING', 1);
    themeCart
      .addItem(id, props)
      // eslint-disable-next-line no-unused-vars
      .then(payload => {
        commit('LOADING', 0);
        return dispatch('updateCart');
      })
      .catch(error => console.log(error));
  },
  updateItem: ({ commit, dispatch }, payload) => {
    commit('LOADING', 1);
    const key = payload.key;
    const props = payload.props;
    themeCart
      .updateItem(key, props)
      .then(state => {
        commit('LOADING', 0);
        return dispatch('updateCart');
      })
      .catch(error => console.log(`updateItem Error: ${error}`));
  },
  removeItem: ({ commit, dispatch }, key) => {
    commit('LOADING', 1);
    themeCart
      .removeItem(key)
      .then(cart => {
        commit('LOADING', 0);
        dispatch('updateCart');
        return commit('REMOVE_ITEM', cart);
      })
      .catch(error => console.log(`removeItem Error: ${error}`));
  },
  updateAttributes: ({ commit }, payload) => {
    commit('LOADING', 1);
    themeCart
      .updateAttributes(payload)
      .then(state => {
        return commit('LOADING', 0);
      })
      .catch(error => console.log(`UpdateAttribute Error: ${error}`));
  },
};

// ----------------------------------
// Mutations
// ----------------------------------
const mutations = {
  UPDATE_CART: (state, payload) => {
    state.cart = payload;
    state.loading = 0;
    // window.eventBus.$emit('cartUpdated', true);
  },
  REMOVE_ITEM: (state, payload) => {
    state.cart = payload;
  },
  LOADING: (state, payload) => {
    state.loading = payload;
  },
  CURRENCY: (state, payload) => {
    state.currency = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
